class SearchboxController {
    constructor($state) {
        this.name = 'searchbox'

        this.$state = $state
    }

    $onInit() {
        if (this.$state.params.search) {
            this.searchWord = this.$state.params.search
        }
    }

    searchPosts() {
        sessionStorage.removeItem('tourists_categories')

        this.$state.go('home', { search: this.searchWord })
    }
}

SearchboxController.$inject = ['$state']

export default SearchboxController



// WEBPACK FOOTER //
// ./client/app/components/home/sidebar/searchbox/searchbox.controller.js